<template>
  <div
    v-if="!user.isRep && (user.props.rep || user.props.customer_rep)"
    class="shopping-with flex-column flex-align-center"
  >
    <div>Shopping With</div>
    <RouterLink
      :to="{
        name: 'consultant',
        params: { consultantId: user.props.customer_rep },
      }"
      class="consultant"
    >
      {{ rep?.name ?? user.props.customer_rep }}
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import { useRepsStore, useUserStore, type UserWithId } from "@/stores/user";
import { computed, onMounted } from "vue";

const user = useUserStore();
const reps = useRepsStore();

const rep = computed(() => {
  return reps.list.find(
    (r: UserWithId) => `${r.rep_number}` === `${user.props.customer_rep}`,
  );
});

onMounted(() => {
  loadRep();
});
async function loadRep() {
  if (!rep.value && user.props.customer_rep && !user.props.rep_number) {
    await reps.sync();
  }
}
</script>

<style scoped>
.consultant {
  display: flex;
  padding: var(--2XS, 8px);
  justify-content: center;
  align-items: center;
  color: var(--Black, #000);
  text-align: center;

  /* Paragraph 2 */
  font-family: Indivisible;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.shopping-with {
  font-size: 14px;
}
</style>
